module.exports = __webpack_public_path__ + "json/grounds-0.json?87d1c5f7c01f72c0b0bbb5b9f9ec3444";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/grounds/grounds-0.json
// module id = 1736
// module chunks = 3